import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { useAnonymousId } from '@ria-client/segment/components/AnonymousIdProvider';

export interface AdUrlParams {
  [key: string]: string;
}

export function buildAdUrl(
  baseUrl: string,
  pathname: string,
  anonymousId: string | null | undefined,
  additionalParams?: AdUrlParams,
): string {
  const url = new URL(baseUrl);
  url.searchParams.set('utm_source', pathname);

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      url.searchParams.set(key, value);
    }
  }

  if (anonymousId) {
    url.searchParams.set('ajs_anonymous_id', anonymousId);
  }

  return url.toString();
}

export function useAdUrl(baseUrl: string, additionalParams?: AdUrlParams): string {
  const anonymousId = useAnonymousId();
  const pathname = usePathname();

  return useMemo(
    () => buildAdUrl(baseUrl, pathname, anonymousId, additionalParams),
    [anonymousId, baseUrl, pathname, additionalParams],
  );
}
